import { FC } from "react";

export const ExtraActions: FC = () => {
  return (
   <svg
    xmlns="http://www.w3.org/2000/svg"
    width={4}
    height={12}
    fill="none"
  >
    <path
      fill="#343A40"
      d="M2 6.667a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333Z"
    />
    <path
      fill="#343A40"
      d="M2.167 6.001a.167.167 0 1 0-.334 0 .167.167 0 0 0 .334 0Zm1 0a1.166 1.166 0 1 1-2.333 0 1.166 1.166 0 0 1 2.333 0ZM2 2A.667.667 0 1 0 2 .667.667.667 0 0 0 2 2Z"
    />
    <path
      fill="#343A40"
      d="M2.167 1.334a.167.167 0 1 0-.334 0 .167.167 0 0 0 .334 0Zm1 0a1.166 1.166 0 1 1-2.333 0 1.166 1.166 0 0 1 2.333 0ZM2 11.333A.667.667 0 1 0 2 10a.667.667 0 0 0 0 1.333Z"
    />
    <path
      fill="#343A40"
      d="M2.167 10.667a.167.167 0 1 0-.334 0 .167.167 0 0 0 .334 0Zm1 0a1.166 1.166 0 1 1-2.333 0 1.166 1.166 0 0 1 2.333 0Z"
    />
  </svg>
  );
};
